import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export type SearchBoxVariant = 'toolbar' | 'global';

/** Input de búsqueda con debounce (component-library.md §2 AppSearchBox). */
@Component({
  selector: 'app-search-box',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-search-box.component.html',
  host: { class: 'block' },
})
export class AppSearchBoxComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  readonly placeholder = input('Buscar…');
  readonly variant = input<SearchBoxVariant>('toolbar');
  readonly value = input('');
  readonly debounceMs = input(300);
  readonly valueChange = output<string>();

  protected readonly control = new FormControl('', { nonNullable: true });

  ngOnInit(): void {
    this.control.setValue(this.value(), { emitEvent: false });
    this.control.valueChanges
      .pipe(
        debounceTime(this.debounceMs()),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((value) => this.valueChange.emit(value));
  }

  clear(): void {
    this.control.setValue('');
  }
}
